export default __webpack_public_path__ + "static/akimed_logo-d39a1102b7f1adae832ff25bc5edc91a.png";